module.exports = __webpack_public_path__ + "assets/img/logo.a38c3ba9.png";